export default {
  home: {
    DownloadApp: "Lade App herunter",
    DIRECTRENT: 'DIREKTVERMIETUNG',
    minute: "Minute",
    price_info:
      "{mianfei} Minuten kostenlos, maximal pro Tag {currencyName}{fengding}, Kaution {currencyName}{yajin}, kostenlose Mietkaution",
    feature_1: "Spezielles Design für kabelloses Laden",
    feature_2: "Nationale universelle Kreditaufnahme und Rückzahlung",
    feature_3: "Vier Lademodi, geeignet für alle Mobiltelefone",
    submit: "Aufladen",
    borrow: "Ausleihen",
    inputcodetitle: "Bitte geben Sie die Gerätenummer am Schrank ein",
    msg_rentcount:
      "Sie haben derzeit {zujieNum} Bestellungen, die nicht abgeschlossen sind",
    cancel: "Stornieren",
    confirm: "Bestätigen",
    msg_fail_title: "Fehler",
    msg_fail_content:
      "Die Miete ist fehlgeschlagen. Bitte versuchen Sie es erneut",
    shoptime: "Geschäftszeit",
    supportrental: "Support-Vermietung",
    supportreturn: "Unterstützen Sie die Rückkehr",
    useragreen:
      "Klicken Sie hier, um dem „Delegierten Einzugsermächtigungsformular“, der „Benutzervereinbarung“ und der „Aufladevereinbarung“ zuzustimmen",
    privacyagreen:
      "Klicken Sie hier, um der Datenschutzvereinbarung zuzustimmen",
    offline:
      "Das Gerät {devicecode} ist offline, bitte wenden Sie sich an das anwesende Personal",
    permissionfail: "Zugriff verweigert.",
    unbound: "Der Mix-QR-Code {devicecode} ist nicht an das Gerät gebunden",
    nobattery: "Im Gerät {devicecode} ist kein Akku verfügbar.",
    分钟: 'minute',
    小时: 'Stunde',
    天: 'Tag'
  },
  loginborrow: {
    start: "Start",
    powerbanktitle: "Schalte die Voozaa Power Bank frei",
    msg_fail_title: "Fehler",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Willst du es nochmal versuchen?",
    msg_rentcount:
      "Sie haben derzeit {zujieNum} Bestellungen, die nicht abgeschlossen sind",
    msg_fail_support: "Das System wird nicht unterstützt",
    msg_fail_confirm: "Bestätigen",
    msg_fail_retry: "Wiederholen",
    msg_fail_cancel: "Stornieren",
    msg_fail_order: "Mietauftrag konnte nicht erstellt werden",
    msg_fail_paymod: "Zahlungsmethode konnte nicht abgerufen werden",
    msg_fail_login: "Fehler bei der Anmeldung",
    Apple: "Apfel",
    otheropt: "Andere Optionen",
    selectmethod: "Wählen Sie eine Bezahlart",
    paymentdetail: "Details zur Zahlungsart",
    couponcode: "Gutscheincode",
    rent: "Bestätige Zahlung",
    pricing: "Siehe Preise",
    phone: "Telefon",
    Google: "Google",
    Facebook: "Facebook",
    loginfb: "Mit Facebook anmelden",
    logingg: "Anmeldung mit Google",
    captcha_code: "Code",
    phonenumber: "Gib deine Telefonnummer ein",
    msg_fail_code: "Bitte den Bestätigungscode eingeben",
    msg_fail_phone: "Bitte geben sie ihre Telefonnummer ein",
    logout: "Konto verlassen",
    savenow: "Jetzt sparen",
    delete: "Löschen",
    addcard: "Geben Sie die Kartendetails ein",
    msg_fail_content:
      "Die Miete ist fehlgeschlagen. Bitte versuchen Sie es erneut",
    title: "Bitte bestätigen Sie die Autorisierung",
    policy: "Politik.",
    term: " Geschäftsbedingungen",
    and: "Und",
    privacy: "Datenschutzrichtlinie.",
    tips: "Indem Sie fortfahren, stimmen Sie unserem zu",
    cancel: "STORNIEREN",
    agree: "ZUSTIMMEN"
  },
  preauth: {
    preauthortitle: "Über die Vorautorisierung",
    tip1:
      "Bei Beginn einer Anmietung wird eine Vorautorisierung Ihrer Zahlungsmethode vorgenommen. Dies dient lediglich dazu, sicherzustellen, dass genügend Mittel zur Verfügung stehen, um Ihre Miete zu bezahlen.",
    tip2:
      "Ihre Bank sendet Ihnen möglicherweise eine Benachrichtigung, es wird jedoch keine Gebühr erhoben: Es wird nur der Preis Ihrer Miete berechnet.",
    tip3:
      "Abhängig von Ihrer Bank kann es einige Stunden bis zu einigen Tagen dauern, bis der Betrag auf Ihren Kontoauszügen angepasst wird. Dies ist normal."
  },
  rentcost: {
    rentcosttitle: "Wie viel kostet die Miete?",
    tip1:
      "Wenn Sie die Powerbank nicht innerhalb von 48 Stunden zurücksenden, wird Ihnen eine Nicht-Rückgabegebühr von {currency} {yajin} berechnet.",
    tip2:
      "Die Dauer wird auf die nächste halbe Stunde (30 oder 60 Minuten) gerundet.",
    tip3:
      "Die Miete für einen Tag beträgt 24 Stunden ab dem Zeitpunkt der Anmietung der Powerbank.",
    tip3_1:
      "Für Ihre Zahlungsmethode wird eine Vorautorisierungsgebühr in Höhe von {currency}{currencyName} {cyajin} erhoben. Damit soll sichergestellt werden, dass ausreichend Geld zur Verfügung steht, um Ihre Miete zu bezahlen.",
    tip3_2:
      "Ihre Bank sendet Ihnen möglicherweise eine Benachrichtigung, es fallen jedoch keine Gebühren an. Es wird nur der Preis Ihrer Miete berechnet.",
    tip3_3:
      "Abhängig von Ihrer Bank kann es einige Stunden bis hin zu einigen Tagen dauern, bis der Betrag auf Ihren Kontoauszügen angepasst wird.",
    tip4:
      "Einige Veranstaltungsorte bieten möglicherweise kostenlose Stunden oder Ermäßigungen an. Genießen!",
    Days: "Tage",
    Hours: "Std",
    Minutes: "Protokoll"
  },
  logincode: {
    login: "Anmeldung",
    retry: "Erneut senden",
    title: "Bestätigungscode",
    subtitle:
      "Bitte geben Sie den Bestätigungscode ein, den wir an Ihre Telefonnummer gesendet haben"
  },
  agreenconfirm: {
    title: "Bitte bestätigen Sie die Autorisierung",
    policy: "Politik.",
    term: "Allgemeine Geschäftsbedingungen von Eternal Technology",
    and: "Und",
    privacy: "Datenschutzrichtlinie.",
    tips: "Ich stimme dem zu",
    cancel: "STORNIEREN",
    agree: "ZUSTIMMEN"
  },
  users: {
    username: "Nutzername",
    mobile: "Handy, Mobiltelefon",
    login: "Anmeldung",
    orders: "Mietaufträge",
    wallet: "Mein Geldbeutel",
    joinus: "Kooperation zum Beitritt",
    langsetting: "Spracheinstellungen"
  },
  login: {
    login_fail: "Fehler bei der Anmeldung",
    phonenumber: "Telefonnummer",
    verificationcode: "Bestätigungscode",
    Rentpowerbank: "Mieten Sie eine Powerbank",
    Rentpowerbanktip: "Geben Sie Ihre Handynummer ein, um zu beginnen",
    phone_number: "Bitte geben Sie eine {0}-stellige Mobiltelefonnummer ein",
    captcha_code: "Code",
    send_code: "Code senden",
    login: "Anmeldung",
    agree: "Indem Sie auf „Anmelden“ klicken, stimmen Sie dem zu",
    readme: `Nutzungsbedingungen`,
    msg_fail_login: "Fehler bei der Anmeldung",
    msg_success_login: "Anmeldung erfolgreich",
    msg_success_login_code:
      "Nach erfolgreichem Empfang laden Sie bitte die APP herunter, um sich anzumelden und zu verwenden",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Willst du es nochmal versuchen?",
    no_sms: "Keine SMS erhalten",
    retry: "Erneut senden",
    receive: "Anwenden",
    invite_pwd: "Einladungscode",
    vip_agreen_tip:
      "Indem Sie fortfahren, erklären Sie, dass Sie unsere akzeptieren",
    vip_agreen_service: "Nutzungsbedingungen",
    vip_agreen_and: "Und",
    vip_agreen_policy: "Datenschutzrichtlinie"
  },
  confirm: {
    title: "Zahlungsbestätigung",
    pay_label: "Menge",
    addcard: "Wallet-Karte hinzufügen",
    price_tips:
      "Klicken Sie, um die Zahlung zu bestätigen und anzuzeigen, dass Sie die gelesen und akzeptiert haben",
    price_btn: "„Mehrwertvereinbarung“",
    pay_type: "Bitte wählen Sie Ihre bevorzugte Zahlungsmethode aus",
    submit: "Mietvertrag bestätigen",
    charge: "Bestätigen Sie das Aufladen",
    msg_fail_title: "Warnung",
    msg_fail_order: "Mietauftrag konnte nicht erstellt werden",
    msg_fail_confirm: "Bestätigen",
    msg_fail_retry: "Wiederholen",
    msg_fail_cancel: "Stornieren",
    confirmpay: "Bestätige Zahlung"
  },
  join: {
    title: "Partnerschaft",
    call: "Anruf",
    tips:
      "Bitte geben Sie Ihre Daten ein, wir werden uns in Kürze bei Ihnen melden!",
    type1: "Installation",
    type2: "Werbung",
    type3: "Andere",
    shop_name: "Name des Händlers",
    contact_person: "Ansprechpartner",
    phone: "Kontakt Nummer",
    submit: "Vorlage",
    noempty: "Kann nicht leer sein"
  },
  mine: {
    title: "Benutzerprofil",
    wallet: "Mein Geldbeutel",
    balance: "Mein Gleichgewicht",
    mywalletcard: "Meine Karte",
    addcard: "Wallet-Karte hinzufügen",
    deposit: "Kaution",
    wallet_in: "Aufladung",
    wallet_out: "Zurückziehen",
    wallet_log: "Wallet-Protokoll",
    order: "Befehl",
    login_tips: "Bitte loggen Sie sich ein",
    msg_fail_title: "Fehler",
    msg_fail_user:
      "Fehler beim Abrufen der Benutzerinformationen. Willst du es nochmal versuchen?",
    help: "Helfen",
    setting: "Einstellung",
    logout: "Ausloggen",
    unpaid: "Unbezahlt",
    using: "In Benutzung",
    getcabinetConfig: "Es liegen noch keine Preisinformationen vor, bitte loggen Sie sich zunächst ein"
  },
  msg: {
    nopaymode: "Die Erfassung der Zahlungsmethode ist fehlgeschlagen",
    unlogin: "Sie sind noch nicht angemeldet, bitte melden Sie sich an",
    msg_fail_title: "Warnung",
    deletecard: "Möchten Sie diese Karte wirklich löschen?",
    loading: "Wird geladen...",
    title: "Tipps",
    success: "Erfolgreiche Operation",
    error: "Unbekannter Fehler, bitte versuchen Sie es später noch einmal.",
    userinfo_fail:
      "Benutzerinformationen ungültig, bitte melden Sie sich erneut an",
    roleerror:
      "Unzureichende Berechtigungen, wenden Sie sich bitte an den Administrator",
    neterror:
      "Netzwerkverbindung fehlgeschlagen. Bitte versuchen Sie es später noch einmal",
    confirm: "Bestätigen",
    retry: "Wiederholen",
    cancel: "Stornieren",
    msg_logout: "Möchten Sie das Konto wirklich verlassen?",
    vieworder: "Bestellung ansehen",
    addorselectcard:
      "Bitte fügen Sie ein Kartenpaket hinzu oder wählen Sie ein Kartenpaket aus, um fortzufahren",
    success_payment: "Bezahlvorgang abgeschlossen",
    fail_payment: "Zahlungsfehler",
    keyword: "Stichwort",
    unpaid_order: "Es liegen unbezahlte Bestellungen vor",
    go_pay: "Geh und bezahle",
    no_more: "nicht mehr",
    noshop: "Keine Händler",
    msg_fail_code: "Bitte den Bestätigungscode eingeben",
    msg_fail_phone: "Bitte geben sie ihre Telefonnummer ein",
    exceedorder:
      "Sie haben bereits eine Bestellung unter Leasing, bitte senden Sie diese zurück, bevor Sie fortfahren",
    sendsuccess: 'Erfolgreiche Schicken',
    copysuccess: 'Erfolg replizieren'
  },
  result: {
    title: "Vermietung bestätigt",
    tips:
      "Um Bestellungen und andere Stationsstandorte anzuzeigen, laden Sie bitte die Anwendung herunter.",
    download: "HERUNTERLADEN",
    vieworder: "Bestellung anzeigen",
    msg_result_loading: "Das Zahlungsergebnis wird bestätigt...",
    msg_tips_loading:
      "Der tragbare Akku taucht auf, bitte warten Sie geduldig ...",
    haveorder: "Der offizielle Auftrag wurde erstellt",
    loading_title: 'Der tragbare Akku taucht auf',
    loading_tips: 'bitte warten Sie geduldig...',
    send: 'Schicken',
    email_tips: 'Sie können Ihre E-Mail-Adresse hinterlassen und wir senden Ihnen die Details dieser Bestellung an Ihre E-Mail-Adresse',
    email: 'E-Mail'
  },
  result_msg: {
    loading: "Wird geladen...",
    refresh: "Aktualisierung"
  },
  order: {
    title: "Mietauftrag",
    in_use: "In Benutzung",
    ended: "Beendet",
    msg_error: "Anfrage fehlgeschlagen",
    no_data: "Keine Daten"
  },
  order_item: {
    order_number: "NEIN.",
    venue_rented: "Veranstaltungsort gemietet",
    time_rented: "Zeit gemietet",
    venue_returned: "Veranstaltungsort zurückgegeben",
    time_returned: "Die Zeit kehrte zurück",
    charge_standard: "Ladestandard",
    rent_occurred: "Es kam zur Miete",
    returned: "Ist zurückgekommen",
    unreturned: "Nicht zurückgegeben",
    type_0: "Nicht vollständig",
    type_1: "Vermietung",
    type_2: "Abgesagt",
    type_3: "Ist zurückgekommen",
    type_4: "Es ist ein Fehler aufgetreten",
    type_5: "Im Laufe der Zeit",
    min: "Mindest",
    unpaid: "Unbezahlt",
    payment: "Zahlung"
  },
  setting: {
    title: "Einstellung",
    lang: "Sprache"
  },
  help: {
    title: "FAQ"
  },
  wallet_in: {
    title: "Mehrwert",
    price_label: "Bitte wählen Sie einen anderen Aufladebetrag aus",
    price_placeholder: "Bitte geben Sie den Aufladebetrag ein",
    balance: "Gleichgewicht",
    chargemoney: "Bitte wählen Sie den Aufladebetrag aus",
    submit: "Einreichen",
    loading: "Wird geladen ...",
    msg_title: "Erinnerung"
  },
  wallet_out: {
    title: "Rückzug",
    price_label: "Bitte geben Sie den Auszahlungsbetrag ein",
    price_placeholder: "Bitte geben Sie den Auszahlungsbetrag ein",
    balance: "Aktueller Kontostand",
    balance_all: "Alle zurückziehen",
    deposit: "Kaution",
    deposit_tips:
      "Es liegt ein Mietvertrag vor. Die Anzahlung von {pcurrencyName}{pyajin} ist nicht erstattungsfähig",
    submit: "Einreichen",
    apply: "Anwenden",
    confirm: "Bestätigen",
    loading: "Wird geladen...",
    msg_fail_price: "Der Auszahlungsbetrag ist falsch",
    msg_fail_balance:
      "Der Auszahlungsbetrag darf nicht größer sein als das aktuelle Guthaben",
    msg_title: "Fehler",
    msg_success_content: "Rückerstattung erfolgreich beantragen",
    tips_title: "Erläuterung",
    btn: "Einreichen",
    error_tips: "Bitte geben Sie vollständige Informationen ein"
  },
  orderDetail: {
    price1: '{pCurrencyName}{pJifei} pro {pJifeiDanwei}{priceUnit}',
    price2: 'Bis zu {pCurrencyName}{pFengding} pro 24 Stunden',
    price3: 'Nichtrückgabegebühr von {pCurrencyName}{overtimeAmount}',
    venuerented: 'Veranstaltungsort gemietet',
    venuereturned: 'Veranstaltungsort zurückgegeben',
    timerented: 'Zeit gemietet',
    timereturned: 'Die Zeit kehrte zurück',
    getreceipt: 'ERHALTEN SIE EINE QUITTUNG',
    buypowerbank: 'Kaufen Sie diese Powerbank',
    usetime: 'Nutze die Zeit',
    estimatedamount: 'Geschätzter Betrag',
    feerule: 'Gebührenordnung',
    onrental: 'Zur Miete',
    revoked: 'Widerrufen',
    returned: 'Zurückgegeben',
    issue: 'Ausgabe',
    overtimereturn: 'Time-out'
  }
};
